module.exports = __webpack_public_path__ + "static/media/teamwork-mobile.394b8f68.png";